import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './useApi';

export interface I18nIcon {
  name?: string;
  description?: string;
  url?: string;
  icon: string;
}

export interface I18nData {
  [locale: string]: {
    [key: string]: unknown;
    search_title?: string;
    search_helper?: string;
    no_results?: string;
    payment_title?: string;
    info_box?: string;
    instructions?: string;
    publishing_models?: {
      [key: string]: I18nIcon;
    };
    payments?: {
      [key: string]: I18nIcon;
    };
    licenses?: {
      [key: string]: I18nIcon;
    };
  };
}

export const useGetI18n = () => {
  const { makeApiRequest } = useApi();

  return useQuery<I18nData>({
    queryKey: ['i18n'],
    queryFn: () => makeApiRequest<I18nData>('/i18n', 'GET'),
  });
};

export const useGetAllI18n = (account: string) => {
  const { makeApiRequest } = useApi();

  return useQuery<I18nData>({
    queryKey: ['all-i18n', account],
    queryFn: () => makeApiRequest(`/custom/${account}/i18n`, 'GET'),
    enabled: !!account,
    retry: 2,
  });
};

export const useUpdateI18n = () => {
  const { makeApiRequest } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<I18nData>) =>
      makeApiRequest<I18nData>('/i18n', 'PUT', data),
    onSuccess: (updatedData) => {
      queryClient.setQueryData(['i18n'], updatedData);
    },
  });
};

export const useUpdateI18nCache = () => {
  const queryClient = useQueryClient();

  return (updatedData: I18nData) => {
    queryClient.setQueryData(['i18n'], updatedData);
  };
};
